"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_1 = require("react-science/ui");
const ChartContext_1 = require("../context/ChartContext");
const BasicToolBar_1 = __importDefault(require("./BasicToolBar"));
const FunctionToolBar_1 = __importDefault(require("./FunctionToolBar"));
function ToolBarInner({ selectedTool }) {
    return ((0, jsx_runtime_1.jsxs)(ui_1.Toolbar, { orientation: "vertical", children: [(0, jsx_runtime_1.jsx)(FunctionToolBar_1.default, { defaultValue: selectedTool }), (0, jsx_runtime_1.jsx)(BasicToolBar_1.default, {})] }));
}
const MemoizedToolBar = (0, react_1.memo)(ToolBarInner);
function ToolBar() {
    const { toolOptions: { selectedTool }, } = (0, ChartContext_1.useChartData)();
    return (0, jsx_runtime_1.jsx)(MemoizedToolBar, { selectedTool });
}
exports.default = ToolBar;
